import React, { ReactNode } from 'react';
import logo from '../../images/logo.svg';

interface Props {
	children: ReactNode;
}

const GuestLayout = (props: Props) => {
	return (
		<div className='position-relative w-100 vh-100 bg-primary overflow-hidden'>
			<img
				src={logo}
				alt='OIA Logo'
				className='position-absolute top-0 left-0 ps-10 pt-7'
			/>
			<div className='position-absolute blur-circle blur-circle-1' />
			<div className='position-absolute blur-circle blur-circle-2' />
			<div className='vh-100 d-flex flex-column justify-content-center align-items-center'>
				{props.children}
			</div>
			<div className='position-absolute bottom-0 left-0 w-100 p-5 bg-white d-flex justify-content-center'>
				<p className='copyright text-decoration-none mb-0'>
					© 2026 <a href='#'>IA Valuations.</a> All Rights Reserved.
				</p>
			</div>
		</div>
	);
};

export default GuestLayout;
